<div [matTooltip]="'Filter'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-filter'"
    (click)="selectTool.emit()"
  >
    <mat-icon>filter_list</mat-icon>
  </button>
</div>
